module.exports = __webpack_public_path__ + "img/Bodice-Back-Jb-Kf-Lb.60ba9602.png";